export enum FirebaseErrorMessages {
  UserNotFound = 'El correo no se encuentra registrado en nuestro sistema, por favor intenta de nuevo',
  UserNotFoundOrWrongPassword = 'El correo no se encuentra registrado en nuestro sistema o su contraseña es incorrecta.',
  EmailAlreadyInUse = 'El correo se encuentra en uso por otra cuenta.',
}
